<template>
    <div class="form-page">
        <my-form
            v-model="form"
            @submit="submitHandler"
            table>
            <my-form-item-group title="添加中标公告">
                <el-form-item
                    label="标段名称"
                    prop="bdcode"
                    class="table-full-row"
                    :rules="newRule('标段名称', 'required','change')">
                    <my-select
                        :disabled="edit"
                        :data="bdlist"
                        v-model="form.bdcode"
                        placeholder="请选择标段名称"
                        :props="{value:'bdcode',label:'bdname'}"
                        @select="gethxr"
                        style="width:100%;">
                    </my-select>
                </el-form-item>
                <el-form-item
                    label="公告名称"
                    prop="by1"
                    class="table-full-row"
                    :rules="newRule('公告名称', 'required','blur')">
                    <el-input
                        type="text"
                        placeholder="请输入公告名称"
                        v-model="form.by1"
                    ></el-input>
                </el-form-item>
                <el-form-item 
                    label="中标公告类型" 
                    prop="ggxzcode"  
                    class="table-full-row"
                    :rules="newRule('中标公告类型', 'required','change')">
                        <my-radio
                            v-model="form.ggxzcode"
                            :data="ggxzList"
                            2way="value"
                            :value.sync="form.ggxzname">
                        </my-radio>
                </el-form-item>
                <el-form-item
                    label="中标人"
                    prop="zbdwcode"
                    :rules="newRule('中标人', 'required','change')">
                    <my-select
                        :data="zbhxrlist"
                        v-model="form.zbdwcode"
                        @select="gethxrxx"
                        placeholder="请选择中标人/未中标人"
                        :props="{value:'zhhxrcode',label:'hxrdwname'}"
                        style="width:100%;"
                    ></my-select>
                </el-form-item>
                <el-form-item
                    label="报价类型"
                    prop="bjlx"
                    :rules="newRule('报价类型', 'required','change')">
                    <my-select
                        :data="bjtypelist"
                        v-model="form.bjlx"
                        placeholder="请选择报价类型"
                        :props="{value:'diccode',label:'dicname'}"
                        style="width:100%;"></my-select>
                </el-form-item>
                <el-form-item
                    label="中标价格"
                    prop="zbbj"
                    v-if="form.bjlx!=='1'"
                    :rules="newRule('中标价格', 'required')"
                    key="zbbj">
                        <el-input
                            type="text"
                            v-model="form.zbbj"
                            placeholder="请输入中标价格"
                            style="width:100%;">
                        </el-input>
                </el-form-item>
                <el-form-item
                    label="中标价格"
                    prop="zbjg"
                    v-if="form.bjlx==='1'"
                    :rules="newRule('中标价格', 'required')"
                    key="zbjg">
                        <el-input-number
                            v-model="form.zbjg"
                            :precision="2"
                            placeholder="请输入中标价格"
                            style="width:100%;">
                        </el-input-number>
                        <my-tag type="danger">只能输入整数和小数</my-tag>
                </el-form-item>
                <el-form-item
                    label="价格币种"
                    v-if="form.bjlx==='1'"
                    :rules="newRule('价格币种', 'required')">
                        <my-select
                            :data="jgdw"
                            v-model="form.jgdwcode"
                            @select="bzyzs"
                            disabled
                            placeholder="请选择价格单位"
                            :props="{value:'diccode',label:'dicname'}"
                            style="width:50%;">
                        </my-select>
                        <span v-if="dwshow" class="active oneposi">请选择价格单位</span>
                        <my-select
                            :data="bztype"
                            v-model="form.bzcode"
                            @select="yzs"
                            disabled
                            placeholder="请选择币种"
                            :props="{value:'diccode',label:'dicname'}"
                            style="width:50%;">
                        </my-select>
                        <span v-if="bzshow" class="active twoposi">请选择币种</span>
                </el-form-item>
                <el-form-item
                    label="委托金额"
                    v-if="form.bjlx==='1'"
                    prop="e_wtje"
                    :rules="newRule('委托金额', 'required')"
                    key="e_wtje">
                    <el-input
                        type="number"
                        placeholder="请输入委托金额"
                        v-model="form.e_wtje"
                        style="width:80%;">
                    </el-input>
                    <span v-if="form.jgdwcode==='1'">元</span>
                    <span v-if="form.jgdwcode==='2'">万元</span>
                    <span v-if="form.bzcode==='156'">人民币</span>
                </el-form-item>
                <el-form-item
                    label="委托金额"
                    v-if="form.bjlx!=='1'"
                    prop="wtbj"
                    :rules="newRule('委托金额', 'required')"
                    key="wtbj">
                    <el-input
                        type="text"
                        placeholder="请输入委托金额"
                        v-model="form.wtbj"
                        style="width:100%;">
                    </el-input>
                </el-form-item>
                <el-form-item
                    label="节资率"
                    v-if="form.bjlx==='1'"
                    prop="e_jzl"
                    key="e_jzl">
                    <el-input
                        type="text"
                        v-model="form.e_jzl"
                        style="width:80%;"
                        disabled>
                    </el-input>
                    <el-button
                        type="primary"
                        @click="reckonjzl()">
                            计算
                    </el-button>
                </el-form-item>
                <el-form-item
                    label="其他说明"
                    prop="qtsm"
                    :rules="newRule('其他说明', 'required')"
                    class="table-full-row">
                    <el-input
                        type="textarea"
                        v-model="form.qtsm"
                        placeholder="请输入其他说明"
                        style="width:100%;">
                    </el-input>
                </el-form-item>
                <el-form-item
                    label="公告内容"
                    prop="detail"  
                    :rules="newRule('公告内容', 'required')" 
                    class="table-full-row">
                        <ueditor v-model="form.detail" />
                </el-form-item>
                <el-form-item
                    label="附件"
                    class="table-full-row">
                    <my-upload
                        :file-guid="form.fileguid|| ''"
                        file-type='jpg、pdf'
                        :file-size="20">
                    </my-upload>
                </el-form-item>
            </my-form-item-group>
            <template
                slot="btn"
                class="btn"
                slot-scope="scope">
                <el-button
                    icon="el-icon-circle-check"
                    type="primary"
                    @click="fSave('1',scope.submitHandler)">
                    提交
                </el-button>
                <el-button
                    icon="el-icon-remove-outline"
                    type="warning"
                    @click="fSave('0',scope.submitHandler)"
                >
                    暂存
                </el-button>
            </template>
        </my-form>
        <Form v-if="xianshi==true" :xianshi="xianshi" :bdcode="bdcode_fh" :bdname="form.bdname" :way='1' :zbprocode="getQuery('zbprocode')" :zbproname="form.zbproname"  @close="close"></Form>
        <div class="v-modal" tabindex="0" style="z-index:2075"></div>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page';
import Form from '@views/bidding/views/project-flow/ding/servicevaluation/components/form.vue'
export default {
    mixins: [FORM_PAGE_MIXIN],
    components: {Form},
    data() {
        return {
            cphMain_txtZbjeDx: '',
            zhongbiaobj: false,
            zhongbiaojiage: true,
            deptcode: '',
            iszfcg: '',
            jgshow: false,
            dwshow: false,
            bzshow: false,
            bjtypelist: [
                { dicname: '金额', diccode: '1' },
                { dicname: '费率/比率/优惠率/合格率等', diccode: '2' },
                { dicname: '单价', diccode: '3' },
                { dicname: '其他形式', diccode: '4' },
            ],
            form: {
                shbj: '',
                bdcode: '',
                bdname: '',
                by1: '',
                fileguid: '',
                bjlx: '',
                typename: '',
                typecode: '',
                tzscode: '',
                zbdwname: '',
                zbdwcode: '',
                jgdwname: '',
                jgdwcode: '1',
                bzname: '',
                bzcode: '156',
                ext_tendercityname: '',
                ext_tendercitycode: '',
                zbjb: '',
                e_wtje: '',
                e_jzl: '',
                isXt: '',
                ggxzcode:''
            },
            bdlist: [],
            zbhxrlist: [],
            jgdw: [],
            bztype: [],
            tzstype: [],
            edit:false,
            xianshi:false,
            bdcode_fh:'',
            ggxzList:[{key:'1', value:'正常'},{key:'2', value:'变更'}]
        };
    },
    computed: {},
    watch: {},
    methods: {
        gethxrxx: function (data) {
            this.form.zbdwname = data.hxrdwname;
        },
        //计算节资率
        reckonjzl: function () {
            //币种单位
            if (
                this.form.jgdwcode === '' ||
                this.form.jgdwcode === null ||
                this.form.jgdwcode === undefined
            ) {
                ShowMsgBox('请先选择币种单位！');
            }
            //中标价格
            else if (
                this.form.zbjg === '' ||
                this.form.zbjg === undefined ||
                this.form.zbjg === null ||
                this.form.e_wtje === '' ||
                this.form.e_wtje === undefined ||
                this.form.e_wtje === null
            ) {
                ShowMsgBox('请添写正确的中标价格或委托金额！');
            } else {
                //（控制价-中标价）/ 控制价 *100%
                this.form.e_jzl =
                    ((Number(this.form.e_wtje) - Number(this.form.zbjg)) /
                        Number(this.form.e_wtje)) *
                    100;
                this.form.e_jzl += '%';
            }
        },
        //验证
        yzs: function (data) {
            if (data) {
                this.form.bzname = data.dicname;
            }
            if (
                this.form.jgdwcode === '' ||
                this.form.jgdwcode === undefined ||
                this.form.jgdwcode === null
            ) {
                this.dwshow = true;
            } else {
                this.dwshow = false;
            }
            if (
                this.form.bzcode === '' ||
                this.form.bzcode === undefined ||
                this.form.bzcode === null
            ) {
                this.bzshow = true;
            } else {
                this.bzshow = false;
            }
        },
        bzyzs: function (data) {
            if (data) {
                this.form.jgdwname = data.dicname;
            }
            if (
                this.form.jgdwcode === '' ||
                this.form.jgdwcode === undefined ||
                this.form.jgdwcode === null
            ) {
                this.dwshow = true;
            } else {
                this.dwshow = false;
            }
            if (
                this.form.bzcode === '' ||
                this.form.bzcode === undefined ||
                this.form.bzcode === null
            ) {
                this.bzshow = true;
            } else {
                this.bzshow = false;
            }
        },
        //获取候选人
        gethxr: function (data) {
            var that = this;
            this.form.bdname = data.bdname;
            if(this.$route.query.ggcode===undefined){
                this.form.by1=data.bdname;
            }
            that.$get(`${this.getGetters('bidUrl')}/revision/DingBiao/ZhongBiaogg/queryExistHxrList.json`,{ 
                bdcode: data.bdcode, 
                isXt: this.$route.query.isXt 
                },(data, res) => {
                    that.zbhxrlist = data.list;
                }
            );
        },
        // 提交
        fSave: function (id, cb) {
            this.form.shbj = id;
            cb();
            this.yzs();
        },
        // 服务评价
        service(){
            var that = this
            that.$get(`${this.getGetters('mngUrl')}/service/pj/queryBdScore.json`,{
                bdcode:that.form.bdcode,
            }, (data, res) => {
           
                if(data!=='不允许弹框！'){
                    console.log(data)
                    this.bdcode_fh=data
                    that.xianshi=true
                    $(".v-modal ").css("display","block");
                }
                else {
                    this.cancleHandler()
                }
            });
        },
        close(val) {
            this.xianshi=val
            $(".v-modal ").css("display","none");
            this.cancleHandler()
        },
        submitHandler: function () {
            var that = this;
            this.form.isXt = this.$route.query.isXt;
            if (this.form.bjlx === '1') {
                if (
                    this.form.jgdwcode === '' ||
                    this.form.jgdwcode === undefined ||
                    this.form.jgdwcode === null
                ) {
                    return;
                }
                if (
                    this.form.bzcode === '' ||
                    this.form.bzcode === undefined ||
                    this.form.bzcode === null
                ) {
                    return;
                }
            }
            if (this.$route.query.ggcode === undefined) {
                that.$post(`${this.getGetters('bidUrl')}/revision/DingBiao/ZhongBiaogg/government/add.json`,this.form,(data, res) => {
                    if (res.result) {
                        ShowMsg(res.msg, 'success');
                         if(that.form.shbj=='1') {
                            that.service()
                        }
                        else {
                            that.cancleHandler()
                        }
                    } else {
                        ShowMsg(res.msg);
                    }
                });
            } else {
                that.$post(`${this.getGetters('bidUrl')}/revision/DingBiao/ZhongBiaogg/government/edit.json`,this.form,(data, res) => {
                    if (res.result) {
                        ShowMsg(res.msg, 'success');
                         if(that.form.shbj=='1') {
                            that.service()
                        }
                        else {
                            that.cancleHandler()
                        }
                    } else {
                        ShowMsg(res.msg);
                    }
                });
            }
        },
    },
    created() {
        var that = this;
        if (this.$route.query.ggcode === undefined) {
            that.$get(`${this.getGetters('bidUrl')}/revision/DingBiao/ZhongBiaogg/queryAddPageData.json`,{
                zbprocode: this.$route.query.zbprocode,
                isXt: this.$route.query.isXt,
            },(data, res) => {
                that.bdlist = data.bdlist;
                that.bztype = data.bztype;
                this.form.fileguid = data.fileguid;
                that.jgdw = data.jgdw;
                that.tzstype = data.tzstype;
                that.form.tzscode = data.tzscode;
                that.deptcode = data.deptcode;
                that.form.ggxzcode = '1';
                that.form.ggxzname = '正常';
            });
        } else {
            that.$get(`${this.getGetters('bidUrl')}/revision/DingBiao/ZhongBiaogg/queryEditPageData.json`,{
                ggcode: this.$route.query.ggcode,
                isXt: this.$route.query.isXt,
            },(data, res) => {
                that.edit = true
                that.bdlist = data.bdlist;
                that.bztype = data.bztype;
                this.form.fileguid = data.fileguid;
                that.jgdw = data.jgdw;
                that.form = data.gginfo;
                that.deptcode = data.deptcode;
                that.gethxr(data.gginfo);
                that.form.jgdwcode = '1';
                that.form.bzcode = '156';
                if(!that.form.ggxzcode){
                    that.form.ggxzcode = '1';
                    that.form.ggxzname = '正常';
                }
            });
        }
    },
    mounted() {
        var that = this;
    },
};
</script>

<style scoped lang="scss">
.active {
    color: #f56c6c;
    font-size: 12px;
}
.oneposi {
    position: absolute;
    left: 5px;
    bottom: -10px;
}
.twoposi {
    position: absolute;
    left: 210px;
    bottom: -10px;
}
.v-modal {
    display: none;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000000;
}
</style>
